import styled from 'styled-components';

import CatalogContentScreenLayout from '~/src/screens/CatalogContent/ContentScreen/CatalogContentScreenLayout';
import ImageSlider from '~/src/screens/CatalogContent/ContentScreen/ImageSlider/ImageSlider';
import { ProductGridArea } from '~/src/screens/CatalogContent/ContentScreen/ProductScreen/constants';
import { media } from '~/src/styles-constants';

import * as S from '../layout';

/* TODO: Move overrides for display none to components style instead of overriding it here once 'configuration-page-produit' is cleaned  */
export const Content = styled(CatalogContentScreenLayout)`
  ${S.NavigationContainer} {
    display: flex;
    padding: 24px 0 16px;
  }

  ${S.BreadcrumbsContainer} {
    display: flex;
  }

  ${media.M`
    margin-top: auto;

    ${S.NavigationContainer} {
      display: flex;
      padding-top: 8px;
    }
  `}
`;

export const GridContent = styled(S.GridContent)`
  grid-template-areas:
    '${ProductGridArea.Gallery}'
    '${ProductGridArea.Header}'
    '${ProductGridArea.Details}'
    '${ProductGridArea.Attributes}';

  ${media.M`
    grid-template-areas: 
    "${ProductGridArea.Breadcrumbs} ${ProductGridArea.Header}"
    "${ProductGridArea.Gallery} ${ProductGridArea.Header}"
    "${ProductGridArea.Details} ${ProductGridArea.Header}"
    "${ProductGridArea.Attributes} ${ProductGridArea.Header}";
  `}
`;

export const Slider = styled(ImageSlider)`
  padding: 0 8px;
`;
